import React, { createContext, useContext, useState, PropsWithChildren } from 'react'

import { Policy } from 'src/api/types/policy'
import useDeepCompareEffect from 'src/commons/hooks/useDeepCompareEffect'
import { useAgencySettings } from 'src/layout/AgencySettings'

export interface ISmartPatrolCtx {
  setSmartPatrol: (state: boolean) => void
  smartPatrolActive: boolean
  smartPatrolThreshold?: number
  toggleSmartPatrol: () => void
}

export interface ISmartPatrolWrapperProps {
  policy: Policy
}

const SmartPatrolCtx = createContext<ISmartPatrolCtx | null>(null)

export function useSmartPatrolContext() {
  const ctx = useContext(SmartPatrolCtx)

  if (!ctx) {
    throw Error('useSmartPatrolContext have to be inside SmartPatrolWrapper')
  }

  return ctx
}

export default function SmartPatrolWrapper({ policy, children }: PropsWithChildren<ISmartPatrolWrapperProps>) {
  const agencySettings = useAgencySettings()
  const [smartPatrolActive, setSmartPatrolActive] = useState(false)
  const [smartPatrolThreshold, setSmartPatrolThresol] = useState(agencySettings.smart_patrol_parking_threshold)

  useDeepCompareEffect(() => {
    // On policy change set smartpatrol value and threshold
    setSmartPatrolActive(policy?.smart_patrol ?? false)
    setSmartPatrolThresol(policy?.parking_auto_confirm_threshold ?? agencySettings.smart_patrol_parking_threshold)
  }, [policy])

  const toggleSmartPatrol = () => {
    setSmartPatrolActive((pendingState) => !pendingState)
  }

  const setSmartPatrol = (state: boolean) => {
    setSmartPatrolActive(state)
  }

  const getValue = (): ISmartPatrolCtx => {
    return {
      smartPatrolActive,
      smartPatrolThreshold,
      setSmartPatrol,
      toggleSmartPatrol,
    }
  }

  return <SmartPatrolCtx.Provider value={getValue()}>{children}</SmartPatrolCtx.Provider>
}
